import TitleService from "@/services/reference/Title.service"

const state = {
    titles: []
}
const getters = {
    getTitleByCode(state) {
        return function (code) {
            return state.titles.filter(el => el.code == code)[0] || {}
        };
    }
}
const actions = {
    async getTitles({ commit }, params) {
        try {
            let res = await TitleService.getList(params)
            commit("SET_TITLES", res.data)
            return res.data
        }
        catch {

        }
    }
}
const mutations = {
    SET_TITLES(state, payload) {
        state.titles = payload.list
    }
}

export const title = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}